import type { Components, Theme } from '@mui/material/styles';
import { surfacePaperStyles } from '../utils/surfacePaperStyles';

export const MUI_ELEVATION_COMPONENTS: Pick<
  Components<Theme>,
  | 'MuiPaper'
  | 'MuiCard'
  | 'MuiTableContainer'
  | 'MuiTooltip'
  | 'MuiMenu'
  | 'MuiPopover'
  | 'MuiAutocomplete'
  | 'MuiDialog'
  | 'MuiDrawer'
  | 'MuiAlert'
> = {
  MuiPaper: {
    defaultProps: {
      elevation: 0,
    },
    styleOverrides: {
      root: ({ theme }) => ({
        boxShadow: theme.elevation.raised1,
      }),
    },
  },
  MuiCard: {
    defaultProps: {
      elevation: 0,
    },
    styleOverrides: {
      root: () => surfacePaperStyles({ radius: 'md', elevation: 'raised1' }),
    },
  },
  MuiTableContainer: {
    styleOverrides: {
      root: () => surfacePaperStyles({ radius: 'md', elevation: 'raised1' }),
    },
  },
  MuiTooltip: {
    styleOverrides: {
      tooltip: () => surfacePaperStyles({ radius: 'sm', elevation: 'overlay1' }),
    },
  },
  MuiMenu: {
    styleOverrides: {
      paper: () => surfacePaperStyles({ radius: 'md', elevation: 'overlay2' }),
    },
  },
  MuiPopover: {
    styleOverrides: {
      paper: () => surfacePaperStyles({ radius: 'md', elevation: 'overlay2' }),
    },
  },
  MuiAutocomplete: {
    styleOverrides: {
      paper: () => surfacePaperStyles({ radius: 'md', elevation: 'overlay2' }),
      listbox: ({ theme }) => ({
        borderRadius: theme.radius.md,
      }),
    },
  },
  MuiDialog: {
    styleOverrides: {
      paper: () => surfacePaperStyles({ radius: 'md', elevation: 'overlay4' }),
    },
  },
  MuiDrawer: {
    styleOverrides: {
      paper: ({ ownerState }) =>
        surfacePaperStyles({
          radius: 'md',
          elevation: ownerState.variant === 'temporary' ? 'overlay4' : 'raised2',
        }),
    },
  },
  MuiAlert: {
    styleOverrides: {
      root: () => surfacePaperStyles({ radius: 'md', elevation: 'raised1' }),
    },
  },
};
